import React, { useEffect, useState } from 'react';

const DISMISSED_KEY = 'pwaInstallDismissedAt';
const DISMISS_DAYS = 14;

function isMobile() {
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function isIos() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

function recentlyDismissed() {
  const dismissedAt = Number(localStorage.getItem(DISMISSED_KEY));
  if (!dismissedAt) return false;
  const daysSince = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);
  return daysSince < DISMISS_DAYS;
}

export default function InstallPWAPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [showIosSteps, setShowIosSteps] = useState(false);

  useEffect(() => {
    if (!isMobile() || isStandalone() || recentlyDismissed()) return;

    if (isIos()) {
      setVisible(true);
      return;
    }

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, String(Date.now()));
    setVisible(false);
    setShowIosSteps(false);
  };

  const handleInstall = async () => {
    if (isIos()) {
      setShowIosSteps(true);
      return;
    }
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="pwa-install-banner">
      <img src="/logo192.png" alt="" className="pwa-install-icon" />
      <div className="pwa-install-text">
        <strong>Install ValueSieve</strong>
        {showIosSteps ? (
          <p>Tap the Share icon, then "Add to Home Screen".</p>
        ) : (
          <p>Add it to your home screen for quick access.</p>
        )}
      </div>
      {!showIosSteps && (
        <button className="pwa-install-btn" onClick={handleInstall}>
          Install
        </button>
      )}
      <button className="pwa-install-dismiss" onClick={dismiss} aria-label="Dismiss">
        ✕
      </button>
    </div>
  );
}
